import React, { use, useContext, useEffect, useState } from "react"
import { empresaService } from "../../../../../../service/EmpresaService";
import { EmpresaContext } from "../../../../../../provider/empresa/EmpresaContext";
import BoxComponent from "../../../../../../components/Box/BoxComponent";
import LabelComponent from "../../../../../../components/Label/LabelComponent";
import { CampoPedidoInputStyle, CampoPedidoLabelStyle } from "../../../../../Pedidos/components/modal/novo_pedido/InfoPedidoComponent";
import TextFieldComponent from "../../../../../../components/TextField/TextFieldComponent";
import TypographyComponent from "../../../../../../components/Typography/ThypographyComponent";
import { formatNumberToDinheiro } from "../../../../../../utils/dinheiro";

interface CarrinhoFormaPgtoProps {
    formaPgto?: number;
    onChangeFormaPgto: (formaPgto: any, index: number) => void;
    itens: any[];
    calculoTotalItens: number;
    isDinheiro: boolean;
    vlrTroco: number;
    onChangeTroco: (formaPgto: any) => void;
}

const EtapaFormaPgtoComponent = (props: CarrinhoFormaPgtoProps) => {
    const { empresa } = useContext(EmpresaContext);

    const [formasPagamento, setFormasPagamento] = useState<any[]>([]);

    useEffect(() => {
        if (empresa && empresa.id) {
            getFormasPagamento(empresa.id);
        }
    }, [empresa]);

    const getFormasPagamento = async (id: number) => {
        try {
            const data = await empresaService.getFormasPgtoPublico(id);
            setFormasPagamento(data);
        } catch (e) {
            console.error(e);
        }
    }

    const renderFormasPagamento = () => {
        return <BoxComponent component="div"
            sx={{ display: "flex", flexDirection: "column", gap: 1.5, overflow: "auto", height: "30dvh", width: "100%" }}
        >
            {formasPagamento && formasPagamento.map((element: any, index: number) => {
                return <LabelComponent key={`forma_pgto_${index}`} htmlFor={`forma_pgto_${index}`}
                    sx={{
                        ...CampoPedidoLabelStyle,
                        height: "auto",
                        display: 'flex',
                        alignItems: 'center', // Alinha o conteúdo verticalmente ao centro
                        padding: '16.2px',
                        borderRadius: '10.4px',
                        border: '1px solid #E5E7EB',
                        opacity: 1,
                        boxSizing: 'border-box',
                        backgroundColor: 'transparent' // Adicione uma cor de fundo se necessário
                    }}
                >
                    <TextFieldComponent
                        id={`forma_pgto_${index}`}
                        type="radio"
                        checked={props.formaPgto === index}
                        onChange={() => props.onChangeFormaPgto(element, index)}
                        sx={{
                            width: "10%",
                            border: "none"
                        }}
                    //value={props.userData?.telefoneCompleto}
                    //onChange={handleChange("telefoneCompleto")}
                    //fullWidth
                    //sx={{ ...CampoPedidoInputStyle }}
                    />

                    <BoxComponent component="div">
                        <TypographyComponent
                            variant="body2" fontWeight="bold"
                            sx={{
                                fontFamily: '"Font 7", sans-serif',
                                fontWeight: "bold",
                                fontSize: '14px',
                                lineHeight: '20px',
                                letterSpacing: '0%',
                                color: '#4A5565',
                                display: 'inline-flex',
                                alignItems: 'center',
                                verticalAlign: 'middle',
                            }}
                        >
                            {element.nome}
                        </TypographyComponent>
                        {/* <TypographyComponent
                            variant="body2"
                            sx={{
                                fontFamily: '"Font 7", sans-serif',
                                fontWeight: 400,
                                fontSize: '14px',
                                lineHeight: '20px',
                                letterSpacing: '0%',
                                color: '#4A5565',
                                display: 'inline-flex',
                                alignItems: 'center',
                                verticalAlign: 'middle'
                            }}
                        >
                            {element.enderecoCompleto}
                        </TypographyComponent> */}
                    </BoxComponent>
                </LabelComponent>
            })}

            {/* {props.userData?.enderecos && props.userData.enderecos.length == 0 && <p>Não tem endereços</p>} */}
        </BoxComponent>
    }

    const renderTroco = () => {
        var vlrTrocoFormatado;

        if (props.vlrTroco) vlrTrocoFormatado = formatNumberToDinheiro(props.vlrTroco);
        else vlrTrocoFormatado = "";

        return <BoxComponent component="div"
            sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", gap: 1.5, height: "50%", width: "100%" }}>
            {/* <TypographyComponent
                variant="body2" fontWeight="bold"
                sx={{
                    fontFamily: '"Font 1", sans-serif',
                    fontWeight: 700,
                    fontSize: '18px',
                    lineHeight: '28px',
                    letterSpacing: '0%',
                    color: '#101828',
                    display: 'inline-flex',
                    alignItems: 'center',
                    verticalAlign: 'middle'
                }}
            >
                Troco
            </TypographyComponent> */}
            <TextFieldComponent
                id="troco"
                label="Troco"
                value={vlrTrocoFormatado}
                onChange={e => props.onChangeTroco(e.target.value)}
                fullWidth
                maskDinheiro
                //sx={{ ...CampoPedidoInputStyle, background: "transparent" }}
                variant="outlined"
                size="small"
                required
            />
        </BoxComponent>
    }

    const renderResumoPedido = () => {
        return <BoxComponent component="div"
            sx={{ display: "flex", flexDirection: "column", gap: 1.5, height: "50%", width: "100%" }}>
            <BoxComponent component="div" sx={{ display: "flex" }}>
                <TypographyComponent
                    variant="h3"
                    sx={{
                        fontFamily: '"Font 2", sans-serif',
                        fontWeight: 700,
                        fontSize: '20px', // Mapeado do token s+
                        lineHeight: '32px',
                        letterSpacing: '0%',
                        color: '#101828',
                        display: 'inline-flex',
                        alignItems: 'center',
                        verticalAlign: 'middle'
                    }}
                >
                    Resumo do pedido
                </TypographyComponent>
            </BoxComponent>
            <BoxComponent component="div" sx={{ display: "flex", flexDirection: "column" }}>
                {props.itens && props.itens.map((element: any, index: number) => {
                    let totalComplementos = 0;

                    if (Array.isArray(element.complementos)) {
                        totalComplementos += element.complementos.reduce(
                            (soma: number, c: any) => soma + c.vlrUnitario,
                            0
                        );
                    }

                    if (Array.isArray(element.complementosEspecificos)) {
                        totalComplementos += element.complementosEspecificos.reduce(
                            (soma: number, c: any) => soma + c.vlrUnitario,
                            0
                        );
                    }

                    return <BoxComponent component="div" sx={{ display: "flex", width: "100%", justifyContent: "space-between" }} key={`item-${index}`}>
                        <TypographyComponent
                            variant="body2"
                            sx={{
                                fontFamily: '"Font 7", sans-serif',
                                fontWeight: 400,
                                fontSize: '14px',
                                lineHeight: '20px',
                                letterSpacing: '0%',
                                color: '#364153',
                                display: 'inline-flex',
                                alignItems: 'center',
                                verticalAlign: 'middle'
                            }}
                        >
                            {element.qtd}x {element.item.titulo}
                        </TypographyComponent>
                        <TypographyComponent
                            variant="body2"
                            sx={{
                                fontFamily: '"Font 7", sans-serif',
                                fontWeight: 600,
                                fontSize: '14px',
                                lineHeight: '20px',
                                letterSpacing: '0%',
                                color: '#101828',
                                display: 'inline-flex',
                                alignItems: 'center',
                                verticalAlign: 'middle'
                            }}
                        >
                            {formatNumberToDinheiro(element.vlrUnitario + totalComplementos)}
                        </TypographyComponent>
                    </BoxComponent>
                })}
            </BoxComponent>
            <BoxComponent component="div" sx={{ display: "flex", justifyContent: "space-between" }}>
                <TypographyComponent
                    variant="body2" fontWeight="bold"
                    sx={{
                        fontFamily: '"Font 1", sans-serif',
                        fontWeight: 700,
                        fontSize: '18px',
                        lineHeight: '28px',
                        letterSpacing: '0%',
                        color: '#101828',
                        display: 'inline-flex',
                        alignItems: 'center',
                        verticalAlign: 'middle'
                    }}
                >
                    Total:
                </TypographyComponent>
                <TypographyComponent
                    variant="body2" fontWeight="bold"
                    sx={{
                        fontFamily: '"Font 1", sans-serif',
                        fontWeight: 700,
                        fontSize: '18px',
                        lineHeight: '28px',
                        letterSpacing: '0%',
                        color: '#101828',
                        display: 'inline-flex',
                        alignItems: 'center',
                        verticalAlign: 'middle'
                    }}
                >
                    {formatNumberToDinheiro(props.calculoTotalItens)}
                </TypographyComponent>
            </BoxComponent>
        </BoxComponent>
    }

    return <BoxComponent
        component="div"
        sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'center',
            width: '100%',
            flexGrow: 1,
            minHeight: 0,
            p: 2,
            px: 3,
            boxSizing: 'border-box',
            overflow: "hidden",
            height: "50%",
            gap: 2
        }}
    >
        {renderFormasPagamento()}
        {props.isDinheiro && renderTroco()}
        {renderResumoPedido()}
    </BoxComponent>
}

export default EtapaFormaPgtoComponent;